module.exports = __webpack_public_path__ + "static/media/him.a3f007c4.jpg";